/* section-announcement-bar.js — extracted from sections/announcement-bar.liquid */
  function initAnnouncementBarSection() {
    document.querySelectorAll('.ann-bar[data-closable]').forEach(function(bar) {
      let key = 'ann-closed-' + bar.dataset.sectionId;
      if (sessionStorage.getItem(key)) { bar.remove(); return; }
      let btn = bar.querySelector('.ann-bar__close');
      if (!btn) return;
      btn.addEventListener('click', function() {
        bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease';
        bar.style.maxHeight = bar.offsetHeight + 'px';
        bar.offsetHeight;
        bar.style.maxHeight = '0';
        bar.style.opacity = '0';
        bar.style.paddingBlock = '0';
        setTimeout(function() { bar.remove(); }, 300);
        sessionStorage.setItem(key, '1');
      });
    });

    /* ── Carousel ── */
    document.querySelectorAll('.ann-bar[data-carousel]').forEach(function(bar) {
      let slides = Array.from(bar.querySelectorAll('.ann-bar__slide'));
      let dots   = Array.from(bar.querySelectorAll('.ann-bar__dot'));
      if (slides.length < 2) return;

      let current  = 0;
      let interval = parseInt(bar.dataset.interval, 10) || 5000;
      let timer;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          clearInterval(timer);
          goTo(parseInt(dot.dataset.index, 10));
          timer = setInterval(function() { goTo(current + 1); }, interval);
        });
      });

      if (bar.dataset.carousel) {
        timer = setInterval(function() { goTo(current + 1); }, interval);
        bar.addEventListener('mouseenter', function() { clearInterval(timer); });
        bar.addEventListener('mouseleave', function() {
          timer = setInterval(function() { goTo(current + 1); }, interval);
        });
      }
    });

    /* ── Language / Country dropdowns ── */
    document.querySelectorAll('.ann-bar__selector-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        let sel = btn.closest('.ann-bar__selector');
        let isOpen = sel.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.ann-bar__selector.is-open').forEach(function(s) {
          s.classList.remove('is-open');
          s.querySelector('.ann-bar__selector-btn').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          sel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function() {
      document.querySelectorAll('.ann-bar__selector.is-open').forEach(function(s) {
        s.classList.remove('is-open');
        s.querySelector('.ann-bar__selector-btn').setAttribute('aria-expanded', 'false');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBarSection);
  } else {
    initAnnouncementBarSection();
  }

  document.addEventListener('shopify:section:load', function(ev) {
    initAnnouncementBarSection();
  });
